
<template lang="pug">
transition(name="fade")
  #debug-info.debug-info(v-if="isShowDebug")
    .hide-debug-info(@click="hideDebug")
      p close
    .clipinfo
      .clip-button(@click="onCopy")
        p copy<br>info
      .copy-message {{copyMessage}}
    .debug-info__inner
      .fps-info
        p.info-title fps
        p.info-time-value current: {{fps}}
        p.info-time-value max: {{maxFps}}
        p.info-time-value min: {{minFps}}
      .general
        p.info-title general
        p.general-info-value {{configText}}
      .renderer-info
        p.info-title renderer info
        ul
          li.programs programs:
            span.programs-value {{programs}}
          li.geometries geometries:
            span.geometries-value {{geometries}}
          li.textures textures:
            span.textures-value {{textures}}
          li.drawcalls drawcalls:
            span.drawcalls-value {{drawcalls}}
          li.lines lines:
            span.lines-value {{lines}}
          li.points points:
            span.points-value {{points}}
          li.triangles triangles:
            span.triangles-value {{triangles}}
      .time-info
        p.info-title time info
        .time-info-value {{timeText}}
</template>

<script>
import {mapState, mapMutations} from 'Vuex'
import copy from 'copy-to-clipboard';

export default {
  props:{
  },
  components: {},
  computed: {
    ...mapState('debug', {
      isShowDebug: 'isShowDebug', 
      renderInfo: 'renderInfo',
      config: 'viewerConfig',
      timeText: 'timeText',
      fps: 'fps',
      minFps: 'minFps',
      maxFps: 'maxFps'}),
    programs(){
      return this.renderInfo['programs'] ? this.renderInfo['programs'].length : 0
    },
    geometries(){
      return this.renderInfo['memory'] ? this.renderInfo['memory'].geometries : 0
    },
    textures(){
      return this.renderInfo['memory'] ? this.renderInfo['memory'].textures : 0
    },
    drawcalls(){
      return this.renderInfo['render'] ? this.renderInfo['render'].calls : 0
    },
    lines(){
      return this.renderInfo['render'] ? this.renderInfo['render'].lines : 0
    },
    points(){
      return this.renderInfo['render'] ? this.renderInfo['render'].points : 0
    },
    triangles(){
      return this.renderInfo['render'] ? this.renderInfo['render'].triangles : 0
    },
    configText(){
      if(!this.config.title)
        return '';
      return `title: ${this.config.title}
defaultMaterial: ${this.config.defaultMaterial}
dirLightIntensity: ${this.config.dirLightIntensity}
ambientLightIntensity: ${this.config.ambientLightIntensity}
envIntensity: ${this.config.envIntensity}
cubemap: ${this.config.cubeMap}
subDirLightIntensity: ${this.config.subDirLightIntensity}
animMode: ${this.config.animMode}
`
    },
    copyMessage(){
      return this.copyMessageData;
    }
  },
  methods: {
    ...mapMutations('debug', {hideDebug: 'hide'}),
    onTouchMove(e){
      e.preventDefault();
    },
    onCopy(e){
      const infoText = this.createInfoText();
      // const listener = (e)=>{
      //     e.clipboardData.setData("text/plain" , infoText);    
      //     e.preventDefault();
      //     document.removeEventListener("copy", listener);
      // }
      // document.addEventListener("copy" , listener);
      // document.execCommand("copy");

      copy(infoText);

      this.copyMessageData = 'copied to clipboard!'
      setTimeout(()=>{
        this.copyMessageData = '';
      }, 1000)
    },
    createInfoText(){
      const date = new Date();
      const datesStr = date.getFullYear()
          + '/' + ('0' + (date.getMonth() + 1)).slice(-2)
          + '/' + ('0' + date.getDate()).slice(-2)
      const url = location.href;
      const windowsize = `${window.innerWidth} * ${window.innerHeight}`
      const pixelRatio = window.devicePixelRatio;
      const userAgent = navigator.userAgent;
      
      const info = `
日付: ${datesStr}
URL: ${url}
UA: ${userAgent}
ウインドウサイズ: ${windowsize}
ピクセルレシオ: ${pixelRatio}

現在のFPS: ${this.fps}
最低FPS: ${this.minFps}

scene: ${this.config.title}
material: ${this.config.defaultMaterial}
drawCall: ${this.drawcalls}
triangles: ${this.triangles}

計測時間: 
${this.timeText}
      `
      return info;
    },
  },
  data(){
    return{
      copyMessageData: ''
    }
  },
  created () {},
  mounted () {
  },
}
</script>


<style lang="stylus" scoped>
@import '~/css/mixins.styl' 
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;


.debug-info
  position fixed
  top 0
  left 0
  color black
  background-color rgba(0, 0, 0, 0.5)
  line-height 1.1rem
  min-height 210px
  width 100%
  z-index 100
  white-space: pre-wrap
  word-wrap:break-word

  .clipinfo
      color #fff
      position absolute
      top 130px
      left 10px

    .clip-button
      width 50px
      height 50px
      center-child()
      border white 1px solid
      cursor pointer
      text-align center
  &__inner
    display flex
    color white
    flex-wrap wrap
    width 100%
    padding 10px 0px 10px 100px
    font-size 12px
    &>*
      margin-right: 10px
      width 200px
    .info-title
      border-bottom white solid 1px
      font-size 14px
    .time-info
      width 300px
    .fps-info
      width 80px
    .general
      width 250px
      
  .hide-debug-info
    color white
    position absolute
    top 60px
    left 10px
    width 50px
    height 50px
    border white 1px solid
    center-child()
    cursor pointer
    

</style>
